import { render, staticRenderFns } from "./DownloadFileCard.vue?vue&type=template&id=6c7ee4d4&scoped=true"
import script from "./DownloadFileCard.vue?vue&type=script&lang=js"
export * from "./DownloadFileCard.vue?vue&type=script&lang=js"
import style0 from "./DownloadFileCard.vue?vue&type=style&index=0&id=6c7ee4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ee4d4",
  null
  
)

export default component.exports